export const ORDER_EMAIL = "richard.malmkvist@jonkopingsskyltfabrik.se";

export const PRODUCT_TYPES = [
  {
    id: "namnbrickor",
    title: "Namnbrickor",
    text: "Beställ namnbrickor med namn, titel och olika utföranden.",
    image: "/art.-0201.jpg",
  },
  {
    id: "yrkestitelsskyltar",
    title: "Yrkestitelsskyltar",
    text: "Beställ yrkestitelsskyltar med tydlig färgmarkering och rolltext.",
    image: "/yrkestitelsskylt.jpg",
  },
];export const NAME_BADGES = [
  {
    id: 1,
    name: "Art.nr 0201",
    desc: "Utan verksamhetsnamn, Format 75x30mm",
    image: "/art.-0201.jpg",
  },
  {
    id: 2,
    name: "Art.nr 0202",
    desc: "Med verksamhetsnamn, En rad, Format 75x30mm",
    image: "/art.-0202.jpg",
  },
  {
    id: 3,
    name: "Art.nr 0205",
    desc: "Utan verksamhetsnamn, med två titlar, Format 75x35mm",
    image: "/art.-0205.jpg",
  },
  {
    id: 4,
    name: "Art.nr 0207",
    desc: "Med verksamhetsnamn, 2 rader, Format 75x30mm",
    image: "/art.-0207.jpg",
  },
];

export const PROFESSION_BADGES = [
  {
    id: 101,
    name: "Yrkestitelsskylt",
    desc: "Välj färg / yrkesroll",
    image: "/yrkestitelsskylt.jpg",
  },
];